(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["personalizacao"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personalization-fields')) {
    class PersonalizationFields extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-pf-panel]');
        this.text = this.querySelector('[data-pf-text]');
        this.file = this.querySelector('[data-pf-file]');
        this.error = this.querySelector('[data-pf-error]');
        this.scope = this.closest('.shopify-section') || document;
        this.maxBytes = 10 * 1024 * 1024;

        this.onPickerChange = (event) => {
          const target = event.target;
          if (target && target.closest && target.closest('variant-picker, swatches-variant-picker-component')) {
            requestAnimationFrame(() => this.sync());
          }
        };
        this.onInput = () => this.validate();

        document.addEventListener('change', this.onPickerChange);
        if (this.text) this.text.addEventListener('input', this.onInput);
        if (this.file) this.file.addEventListener('change', this.onInput);
        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onPickerChange);
      }

      selectedValue() {
        const name = this.dataset.optionName;
        const radios = this.scope.querySelectorAll('variant-picker input[type="radio"]');
        for (const radio of radios) {
          if (radio.checked && radio.dataset.optionName === name) return radio.value;
        }
        const selects = this.scope.querySelectorAll('variant-picker select');
        for (const select of selects) {
          if (select.name === 'options[' + name + ']') return select.value;
        }
        return null;
      }

      sync() {
        const value = this.selectedValue();
        const active = value === null ? this.dataset.initial === 'true' : value === this.dataset.trigger;
        this.setActive(active);
      }

      setActive(active) {
        if (this.panel) this.panel.hidden = !active;
        if (this.text) this.text.disabled = !active;
        if (this.file) this.file.disabled = !active;
        const productForm = this.scope.querySelector('product-form-component');
        if (productForm) productForm.classList.toggle('pf-personalised', active);
        this.validate();
      }

      validate() {
        if (!this.text || !this.file) return;
        this.text.setCustomValidity('');
        this.file.setCustomValidity('');
        if (this.error) {
          this.error.hidden = true;
          this.error.textContent = '';
        }
        if (this.text.disabled) return;

        const selected = this.file.files && this.file.files[0];
        if (selected && selected.size > this.maxBytes) {
          const message = this.dataset.sizeMessage;
          this.file.setCustomValidity(message);
          if (this.error) {
            this.error.textContent = message;
            this.error.hidden = false;
          }
          return;
        }
        if (!this.text.value.trim() && !selected) {
          this.text.setCustomValidity(this.dataset.message);
        }
      }
    }
    customElements.define('personalization-fields', PersonalizationFields);

    document.addEventListener('formdata', (event) => {
      const form = event.target;
      if (!form || !form.id || form.id.indexOf('BuyButtons-ProductForm-') !== 0) return;
      const data = event.formData;
      Array.from(data.entries()).forEach(([key, value]) => {
        if (key.indexOf('properties[') === 0 && value instanceof File && value.size === 0) {
          data.delete(key);
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
